import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Col, InputGroup, Input, Button } from "reactstrap";
import "../Styles/CohortCardsStyle.css"
import { SearchParamsType } from "../Types/SearchParamsType";
import { Api } from "../Services/CohortServices";
import { useState } from "react";

interface SearchBarComponentProps<T> {
  searchPlaceholder: string;
  buttonName: string;
  buttonRoute: string;
  setFilteredClient: React.Dispatch<React.SetStateAction<T[]>>;
  isLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SearchBarComponent = <T,>(params: SearchBarComponentProps<T>) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParam, setSearchParam] = useState("");
  const {id} = useParams<{id: string}>();
  
  const handleButtonNavigate = () => {
    navigate(params.buttonRoute);
  };

  const handleSearch = async (args: string) => {
    if (!args.trim()) {
      params.setFilteredClient([]);
      return;
    }

    params.isLoading(true);

    try {
      let response;
      let requestParams: SearchParamsType = {}; // Tipo correto dos parâmetros

      if (location.pathname === "/users") {
        if (args.includes("@")) {
          requestParams.email = args;
          requestParams.table = "users";
        } else {
          requestParams.userName = args;
          requestParams.table = "users";
        };
        response = await Api.get("/filters-param", { params: requestParams });
      } else if (location.pathname === "/cohorts") {
        requestParams.Tag = Number(args);
        requestParams.table = 'cohorts'
        response = await Api.get("/filters-param", { params: requestParams });
      } else {
        //verifica se sao apenas numeros no input
        let regexNumberVerify = /^[0-9]+$/;
        if (regexNumberVerify.test(args)) {
          requestParams.cpf = args;
          requestParams.cohortId = Number(id);
        } else {
          requestParams.userName = args;
          requestParams.cohortId = Number(id);
        }
        response = await Api.get("/filter-client", { params: requestParams });   
      }

      params.setFilteredClient(response.data.filters || []);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      params.isLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-between mt-3">
      <Col md={6} className="p-1 text-center">
        {/* Filtro de Pesquisa */}
        <InputGroup className="gap-2">
          <Input
            type="text"
            placeholder={`🔍 ${params.searchPlaceholder}`}
            className="search_input"
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch(searchParam)} // Captura o Enter
          />
          <Button
            className="cohort_search_button"
            onClick={() => handleSearch(searchParam)}
            style={{ 
              borderRadius: "0.85rem",
              border: "none",
              background: "inherit",
              boxShadow:"0 0 0.1rem 0.1rem #F0F2F5",
              color: "#000",
              fontSize: "0.575rem",
            }}
          >
            Buscar
          </Button>
        </InputGroup>
      </Col>
      <Col md={4} className="p-1 text-center"></Col>
      <Col md={2} className="p-1 text-center">
        <Button className="cohort_create_button" onClick={handleButtonNavigate}>
          {params.buttonName}
        </Button>
      </Col>
    </div>
  );
};
